import type { Editor } from '@tiptap/core';
import { useLayoutEffect } from 'react';

/**
 * Re-attaches the EditableLink bubble once EditorContent has committed.
 *
 * EditorContent sets editor.contentComponent in componentDidMount, which can
 * land after the extension's onCreate already built the link bubble's
 * ReactRenderer against a missing host (iFixit/ifixit#64001). Call this from
 * the component that renders EditorContent: the child's componentDidMount runs
 * before the parent's layout effect in the same commit, so the host exists by
 * the time the command looks for it.
 *
 * A layout effect, not a passive one: when a Suspense ancestor hides and
 * re-shows the subtree, React re-runs class componentDidMount (EditorContent
 * gets a fresh, empty host) and reconnects layout effects, but leaves passive
 * effects alone, so only a layout effect sees every new host.
 */
export function useAttachLinkEditor(editor: Editor | null): void {
   useLayoutEffect(() => {
      if (!editor || editor.isDestroyed) {
         return;
      }

      editor.commands.attachLinkEditor();
   }, [editor]);
}
